import * as React from 'react';
import MainLogo from 'src/images/sense-logo-new-white.svg';
import {UnstyledButton} from '@spaced-out/ui-design-system/lib/components/Button';
import {
  CollapseHamburgerMenu,
  ExpandHamburgerMenu,
} from 'src/components/app-shell/hamburger-menu';
import css from './side-nav-header.css';


type SideNavHeaderProps = {
  expanded: boolean;
  setExpand: (arg1: boolean) => void;
};

export const SideNavHeader = ({expanded, setExpand}: SideNavHeaderProps) => {
  return (
    <div className={css.headerContainer}>
      {expanded && <MainLogo className={css.logo} />}
      <UnstyledButton
        ariaLabel={expanded ? 'Collapse Side Nav' : 'Expand Side Nav'}
        onClick={() => setExpand(!expanded)}
        className={css.headerButton}
        tabIndex={0}
      >
        {expanded ? <CollapseHamburgerMenu /> : <ExpandHamburgerMenu />}
      </UnstyledButton>
    </div>
  );
};
